import React, { FC } from 'react';
import { ArticleTwoColumnsBlock as Data } from '../../../graphql/generated/api-graphql';
import ArticleBlock, { ArticleBlockProps } from '../../../components/molecules/ArticleBlock';
import { wediaImagesTransform } from '../../Common/wedia';
import { fixURL } from '../../../helpers/StringHelpers';
import { HtmlLayout } from '../../../components/atoms/Html/types';
export type ArticleTwoColumnBlockProps = {
  data: Data;
};
const ArticleTwoColumnsBlock: FC<ArticleTwoColumnBlockProps> = ({
  data
}) => {
  const props: ArticleBlockProps = {
    htmlProps: data?.description ? {
      text: fixURL(data.description),
      layout: HtmlLayout.article
    } : undefined,
    pictureProps: data?.imageDesktop ? {
      maxWidth: 910,
      withHD: true,
      alt: data.imageDesktop.alt ?? '',
      images: wediaImagesTransform(data?.imageDesktop)
    } : undefined
  };
  return <ArticleBlock {...props} />;
};
export default ArticleTwoColumnsBlock;